import { Controller } from "@hotwired/stimulus"
import { turboSubmit } from "../helpers/html_fetch"

// The theme-name meta can only be: "light", "dark".
// The color-scheme meta can be: "light dark", "light", "dark".
// The themes can be: "auto", "light", "dark".

export default class extends Controller {
  static targets = ["nameMeta", "schemeMeta"]

  static values = {
    updateUrl: String,
  }

  connect() {
    this.#applyTheme(this.#userPreference)

    // Listen to system scheme changes (there's no window event to listen to)
    this.#matchMedia.addEventListener("change", this.#updateNameMetaFromBrowser)
  }

  disconnect() {
    this.#matchMedia.removeEventListener("change", this.#updateNameMetaFromBrowser)
  }

  chooseTheme(e) {
    this.#updateTheme(e.target.value)
  }

  toggleTheme() {
    const theme = this.#currentTheme == "dark" ? "light" : "dark"
    this.#updateTheme(theme)
  }

  #updateTheme(theme) {
    this.#saveUserPreference(theme)
    this.#applyTheme(theme)
  }

  #applyTheme(theme) {
    const themes = ["auto", "light", "dark"]
    const classes = document.documentElement.classList
    themes.forEach(t => classes.toggle(`theme-${t}`, t == theme))

    this.#updateNameMeta()
  }

  // Handle system settings change when theme is auto
  #updateNameMetaFromBrowser = () => {
    if (this.#userPreference !== "auto") return
    this.#updateNameMeta()
  }

  #updateNameMeta() {
    this.nameMetaTarget.content = this.#currentTheme
  }

  get #currentTheme() {
    const classes = document.documentElement.classList
    if (classes.contains("theme-dark")) return "dark"
    if (classes.contains("theme-light")) return "light"
    return this.#systemTheme
  }

  get #systemTheme() {
    return this.#matchMedia.matches ? "dark" : "light"
  }

  get #userPreference() {
    const scheme = this.schemeMetaTarget.content
    return scheme == "light dark" ? "auto" : scheme
  }

  set #userPreference(theme) {
    this.schemeMetaTarget.content = theme == "auto" ? "light dark" : theme
  }

  get #matchMedia() {
    return window.matchMedia("(prefers-color-scheme: dark)")
  }

  #saveUserPreference(theme) {
    this.#userPreference = theme
    if (!this.updateUrlValue) return

    turboSubmit(this.updateUrlValue, {
      method: "PUT",
      body: {"option[value]": theme},
    })
  }
}
